import { apiGetList, apiGetOne, apiCreate, apiUpdate, } from '@/actions/ApiBaseActions';
/** 一覧取得 */
export const API_GET_LIST_PROFESSIONAL_RFP_LIST = 'API_GET_LIST_PROFESSIONAL_RFP_LIST';
/** 詳細取得 */
export const API_GET_ONE_PROFESSIONAL_RFP = 'API_GET_ONE_PROFESSIONAL_RFP';
export const API_GET_ONE_PROFESSIONAL_RFP_SUCCESS = 'API_GET_ONE_PROFESSIONAL_RFP_SUCCESS';
/** 追加資料のダウンロード */
export const API_GET_ONE_PROFESSIONAL_RFP_DOWNLOAD_ADDITIONAL_FILES = 'API_GET_ONE_PROFESSIONAL_RFP_DOWNLOAD_ADDITIONAL_FILES';
/** 閲覧申請 */
export const API_CREATE_PROFESSIONAL_RFP_VIEW_REQUEST = 'API_CREATE_PROFESSIONAL_RFP_VIEW_REQUEST';
/** 提案更新 */
export const API_UPDATE_PROFESSIONAL_RFP_PROPOSAL = 'API_UPDATE_PROFESSIONAL_RFP_PROPOSAL';
/** 募集中の案件一覧取得 */
export const apiGetListRfp = ({ query }, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_RFP_LIST, '/professional/rfp', query, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/** 案件詳細取得 */
export const apiGetOneRfp = ({ path: { id } }, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL_RFP, `/professional/rfp/${id}`, Object.assign(Object.assign({}, meta), { id, isSnakeCase: true }));
/** 案件の追加資料DL */
export const apiGetOneRfpDownloadAdditionalFiles = ({ path: { id } }, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL_RFP_DOWNLOAD_ADDITIONAL_FILES, `/professional/rfp/${id}/download_additional_files`, Object.assign(Object.assign({}, meta), { id, isBlob: true }));
/** 案件に対して閲覧申請を作成 */
export const apiCreateRfpViewRequest = ({ path: { id } }, meta) => apiCreate(API_CREATE_PROFESSIONAL_RFP_VIEW_REQUEST, `/professional/rfp/${id}/view_request`, {}, Object.assign({}, meta));
/** 閲覧申請の提案意向を更新 */
export const apiUpdateRfpProposal = ({ json, path: { id } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_RFP_PROPOSAL, `/professional/rfp/${id}/proposal`, json, Object.assign(Object.assign({}, meta), { id }));
